export const headerMenu = [
  {
    title: "Blog",
    path: "/blogs",
  },
  {
    title: "Contact Us",
    path: "/contact-us",
  },
  {
    title: "Activities",
    path: "/activities",
  },
  {
    title: "Programs",
    path: "/program",
  },
  {
    title: "Home",
    path: "/",
  },
];

export const RECAPTCHA_SITE_KEY=process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const RECAPTCHA_SECRET_KEY=process.env.REACT_APP_RECAPTCHA_SECRET_KEY;
export const LOCAL_SECRET_KEY = process.env.REACT_APP_LOCAL_SECRET_KEY;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;


export const API_URL = process.env.REACT_APP_API_URL;
